<template>
  <i :class="'ri-' + icon" aria-hidden="true"></i>
</template>

<script>
import 'remixicon/fonts/remixicon.css'
import { defineComponent, ref } from "vue"
  export default defineComponent({
    name: 'VabIcon',
    props: {
      icon: {
        type: String,
        required: true,
      },
    },
  })
</script>

<style lang="less" scoped>
  [class*='ri'] {
    font-size: 24px;
    vertical-align: -1px;
  }
</style>